var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Eye-"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Eye",
    transform: "translate(3 3.65)",
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.246 12.943l.707-.707C2.04 10.69 1.008 8.858.996 8.854c.027-.056 3.086-5.515 8.493-5.515a8 8 0 012.834.527l.764-.764a8.972 8.972 0 00-3.598-.763C3.427 2.34.12 8.366.102 8.406a.968.968 0 000 .865c.019.034 1.104 1.99 3.144 3.672",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.703 4.729l-.708.707c1.795 1.447 2.832 3.15 2.977 3.403-.188.335-3.226 5.5-8.483 5.5a7.947 7.947 0 01-2.857-.54l-.77.77a8.983 8.983 0 003.627.77c5.715 0 8.982-5.36 9.359-6.021a.83.83 0 00.004-.951c-.165-.29-1.253-2.08-3.15-3.639",
    id: "Fill-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.986 17.324a.5.5 0 010-.707L17.25.353a.5.5 0 11.707.707L1.693 17.324a.5.5 0 01-.707 0z",
    id: "Fill-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.364 8.067c.067.246.107.504.107.771 0 1.655-1.346 3-3 3-.268 0-.525-.04-.772-.107l-.78.781c.477.205 1 .326 1.552.326 2.206 0 4-1.793 4-4 0-.552-.12-1.075-.327-1.552l-.78.781z",
    id: "Fill-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.583 9.606a2.957 2.957 0 01-.112-.768c0-1.654 1.346-3 3-3 .267 0 .521.046.767.112l.794-.793a3.963 3.963 0 00-1.56-.319c-2.206 0-4 1.794-4 4 0 .554.112 1.081.317 1.561l.794-.793z",
    id: "Fill-11"
  }))))));
}
SvgEye.displayName = 'Eye';
export default SvgEye;